import {connect} from "react-redux";
//empty functions for web (no call or foreground service)

export const isCallKeepActive = async () => {
    // promise that always resolves to true
    return new Promise((resolve) => {
        resolve(true);
    });
}
const CallKeepManagerM = () => {


    return null;
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object
    };
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(CallKeepManagerM);